import { useNavigate } from "react-router-dom";
import { FooterLogoType } from "./Layout";

const SOCIAL_LINKS = {
  TWITTER: "https://x.com/ChimpersHQ",
  TIKTOK: "https://www.tiktok.com/@chimpersofficial?lang=en",
} as const;

const BKFC_SOCIAL_LINKS = {
  TWITTER: "https://x.com/bareknucklefc",
  INSTAGRAM: "https://www.instagram.com/bareknucklefc",
} as const;

interface FooterProps {
  showLogo?: FooterLogoType;
}

export const Footer = ({ showLogo = "none" }: FooterProps) => {
  const navigate = useNavigate();

  return (
    <>
      <div>
        {showLogo === "ripndip" && (
          <img src="/images/ripndip/ripndip-footer.png" alt="Ripndip Logo" className="mx-auto w-44 mb-[6px]" />
        )}
        {showLogo === "ponke" && (
          <img src="/svg/ponke-logo.svg" alt="Ponke Logo" className="mx-auto" />
        )}

        {showLogo === "chimpers" && (
          <img
            src="/svg/chimpers-logo.svg"
            alt="Chimpers Logo"
            className="mx-auto"
          />
        )}

        {showLogo === "catgame" && (
          <img src="/svg/catgame/catgame-icon.svg" alt="CatGame Icon" className="mx-auto" />
        )}

        {showLogo === "mew" && (
          <img src="/svg/mew/mew-icon.svg" alt="Mew Logo" className="mx-auto" />
        )}

        {showLogo === "bkfc" && (
          <div className="pt-2">
            <img
              src="/images/bkfc/bkfc-badge.png"
              alt="BKFC Logo"
              className="mx-auto h-[68px]"
            />

            <div className="flex items-center justify-center gap-3 mt-4">
              <img
                src="/svg/bkfc/x-icon.svg"
                alt="X"
                className="w-6 h-6 cursor-pointer transition-opacity hover:opacity-70"
                onClick={() =>
                  window.open(
                    BKFC_SOCIAL_LINKS.TWITTER,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />

              <img
                src="/svg/bkfc/instagram-icon.svg"
                alt="Instagram"
                className="w-6 h-6 cursor-pointer transition-opacity hover:opacity-70"
                onClick={() =>
                  window.open(
                    BKFC_SOCIAL_LINKS.INSTAGRAM,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              />
            </div>

            <img
              src="/images/powerbyaptos.png"
              alt="Powered by Aptos"
              className="mx-auto mt-4 h-[14px] w-auto"
            />
          </div>
        )}

        {showLogo === "teddymoo" && (
          <div>
            <img src="/svg/teddymoo/teddymoo-logo.svg" alt="TeddyMoo Logo" className="mx-auto" />


            <div className="flex items-center justify-center gap-3 mt-4">
              <svg
                width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                onClick={() =>
                  window.open(
                    SOCIAL_LINKS.TWITTER,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }>
                <path d="M14.2832 10.1621L23.2176 0H21.1004L13.3429 8.82384L7.14678 0H0L9.36944 13.343L0 24H2.1172L10.3093 14.6813L16.8532 24H24L14.2823 10.1621H14.2832ZM11.3831 13.4606L10.4339 12.132L2.88 1.55952H6.13232L12.2283 10.0915L13.1776 11.4202L21.1014 22.511H17.849L11.3831 13.4606Z" fill="#838383" />
              </svg>


              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3063_1908)">
                  <path d="M12.2441 -0.242188C7.23405 -0.242188 5.76885 -0.237018 5.48421 -0.213385C4.4561 -0.127902 3.81633 0.0340309 3.11937 0.381119C2.58225 0.647927 2.15865 0.957167 1.74057 1.3907C0.979175 2.18129 0.517727 3.15382 0.350687 4.31006C0.269471 4.87118 0.245855 4.98566 0.241055 7.8527C0.239209 8.80836 0.241055 10.0661 0.241055 11.7529C0.241055 16.7601 0.246592 18.2243 0.270587 18.5087C0.353648 19.5094 0.510541 20.139 0.842795 20.8277C1.47776 22.146 2.69046 23.1356 4.11903 23.5049C4.61372 23.6323 5.16006 23.7024 5.86148 23.7357C6.15865 23.7486 9.18764 23.7578 12.2184 23.7578C15.2491 23.7578 18.28 23.7541 18.5697 23.7394C19.3819 23.7011 19.8535 23.6378 20.3749 23.503C21.0833 23.3213 21.7435 22.9871 22.3094 22.5237C22.8752 22.0604 23.3332 21.479 23.6512 20.8203C23.9769 20.1483 24.1422 19.4947 24.2169 18.5462C24.2331 18.3394 24.24 15.0425 24.24 11.7499C24.24 8.45686 24.2326 5.16598 24.2163 4.9591C24.1419 3.9955 23.9759 3.3475 23.6396 2.66254C23.3636 2.10171 23.0574 1.68295 22.6124 1.25482C21.8185 0.496345 20.8477 0.0347533 19.6907 -0.132143C19.1303 -0.213195 19.0184 -0.237198 16.1502 -0.242183L12.2441 -0.242188Z" fill="#838383" />
                  <path d="M12.2441 -0.242188C7.23405 -0.242188 5.76885 -0.237018 5.48421 -0.213385C4.4561 -0.127902 3.81633 0.0340309 3.11937 0.381119C2.58225 0.647927 2.15865 0.957167 1.74057 1.3907C0.979175 2.18129 0.517727 3.15382 0.350687 4.31006C0.269471 4.87118 0.245855 4.98566 0.241055 7.8527C0.239209 8.80836 0.241055 10.0661 0.241055 11.7529C0.241055 16.7601 0.246592 18.2243 0.270587 18.5087C0.353648 19.5094 0.510541 20.139 0.842795 20.8277C1.47776 22.146 2.69046 23.1356 4.11903 23.5049C4.61372 23.6323 5.16006 23.7024 5.86148 23.7357C6.15865 23.7486 9.18764 23.7578 12.2184 23.7578C15.2491 23.7578 18.28 23.7541 18.5697 23.7394C19.3819 23.7011 19.8535 23.6378 20.3749 23.503C21.0833 23.3213 21.7435 22.9871 22.3094 22.5237C22.8752 22.0604 23.3332 21.479 23.6512 20.8203C23.9769 20.1483 24.1422 19.4947 24.2169 18.5462C24.2331 18.3394 24.24 15.0425 24.24 11.7499C24.24 8.45686 24.2326 5.16598 24.2163 4.9591C24.1419 3.9955 23.9759 3.3475 23.6396 2.66254C23.3636 2.10171 23.0574 1.68295 22.6124 1.25482C21.8185 0.496345 20.8477 0.0347533 19.6907 -0.132143C19.1303 -0.213195 19.0184 -0.237198 16.1502 -0.242183L12.2441 -0.242188Z" fill="#838383" />
                  <path d="M12.24 15.4976C14.3457 15.4976 16.0528 13.7906 16.0528 11.6848C16.0528 9.5791 14.3457 7.87207 12.24 7.87207C10.1343 7.87207 8.42725 9.5791 8.42725 11.6848C8.42725 13.7906 10.1343 15.4976 12.24 15.4976Z" stroke="white" stroke-width="1.70598" />
                  <path d="M15.9139 3.63867H8.56563C6.09102 3.63867 4.08496 5.64473 4.08496 8.11934V15.3939C4.08496 17.8685 6.09102 19.8746 8.56563 19.8746H15.9139C18.3885 19.8746 20.3946 17.8685 20.3946 15.3939V8.11934C20.3946 5.64473 18.3885 3.63867 15.9139 3.63867Z" stroke="white" stroke-width="1.72852" />
                  <path d="M17.092 8.08444C17.6903 8.08444 18.1753 7.59946 18.1753 7.00121C18.1753 6.40295 17.6903 5.91797 17.092 5.91797C16.4938 5.91797 16.0088 6.40295 16.0088 7.00121C16.0088 7.59946 16.4938 8.08444 17.092 8.08444Z" fill="white" />
                </g>
                <defs>
                  <clipPath id="clip0_3063_1908">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

            </div>
          </div>

        )}

        <div className="flex justify-center p-6 pt-1.5">
          <div className={`flex gap-4 items-center ${(showLogo === "teddymoo" || showLogo === "bkfc") && 'justify-between w-full'}`}>
            <div onClick={() => navigate("/")}>
              <img src="/svg/223-logo.svg" alt="223 Logo" />
            </div>

            <p className="text-sm md:text-base">
              © {showLogo === "bkfc" ? "2026" : "2025"} All Rights Reserved
            </p>

            {
              showLogo !== "teddymoo" && showLogo !== "bkfc" && (
                <div className="flex gap-3 items-center">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="transition-opacity cursor-pointer hover:opacity-70"
                    onClick={() =>
                      window.open(
                        SOCIAL_LINKS.TWITTER,
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  >
                    <g clipPath="url(#clip0_118_1303)">
                      <mask
                        id="mask0_118_1303"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="25"
                        height="25"
                      >
                        <path d="M0.5 0.5H24.5V24.5H0.5V0.5Z" fill="white" />
                      </mask>
                      <g mask="url(#mask0_118_1303)">
                        <path
                          d="M19.4 1.625H23.0806L15.0406 10.8376L24.5 23.3759H17.0943L11.2897 15.773L4.65543 23.3759H0.971429L9.57029 13.5187L0.5 1.62671H8.09429L13.3331 8.57471L19.4 1.625ZM18.1057 21.1679H20.1457L6.98 3.71814H4.79257L18.1057 21.1679Z"
                          fill="#838383"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_118_1303">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0.5 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              )
            }

          </div>
        </div>
      </div>
    </>
  );
};
